import { Box, Card, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Form from './components/form';
import backgroundImage from '../../../../assets/background.png';
import { useEffect } from 'react';
import { AUTH_TOKEN } from '../../../constants/localStorageKey';

const LoginPage = () => {
  useEffect(() => {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (token) {
      window.location.href = '/';
    }
  }, []);

  // if (checkAuthCtrl.loading) {
  //   return <LoadingBakdrop />;
  // }

  return (
    <>
      <Helmet>
        <title> Login </title>
      </Helmet>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { md: 0, xs: '20px' },
          height: { md: '100vh', xs: 'calc(100vh - 40px)' },
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Card
          sx={{
            px: { md: 13, xs: 4 },
            py: { md: 10, xs: 8 },
            width: 1,
            maxWidth: 543,
          }}
        >
          <Typography fontSize={40} sx={{ mb: 7.5, textAlign: 'center' }}>
            ເຂົ້າສູ່ລະບົບ
          </Typography>

          <Form />
        </Card>
      </Box>
    </>
  );
};

export default LoginPage;
